<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <MEM_heroLanding />
        <MEM_highLights :clientWidth="clientWidth"/>
        <MemberProduct :clientWidth="clientWidth"/>

        <div>market</div>
    </main>

</template>


<script>
    import MEM_heroLanding from "../../components/content/member/index/MEM_heroLanding";
    import MEM_highLights from "../../components/content/member/index/MEM_highLights";
    import MemberProduct from "../../components/content/member/index/MemberProduct";


    export default {
        name: 'market',
        components: {
            MEM_heroLanding,
            MEM_highLights,
            // MEM_twoTout,
            MemberProduct,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {
            let that = this;
            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
